export enum UpsellType {
    ADULT_SIGNATURE = 'ADULT_SIGNATURE',
    STANDARD = 'STANDARD',
    PROOF_OF_DELIVERY = 'PROOF_OF_DELIVERY',
    ENHANCED = 'ENHANCED',
    PRINT_IN_STORE = 'PRINT_IN_STORE',
}

export interface IUpsell {
    amount: number;
    coverage: number;
    currency: string;
    type: UpsellType;
}
